import React from 'react';

import { StopCircleIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import i18n from 'i18next';

export const CancelCell = ({
  onCancelHandler,
  row,
}) => {
  const { original: { task_status } } = row;
  if (![0, 1].includes(task_status)) return null;
  return (
    <div title={i18n.t('tasks:подтверждение.остановка задачи.title')}>
      <Control.IconButton
        data-testid="cancelCell"
        icon={<StopCircleIcon />}
        kind="primary"
        onClick={() => onCancelHandler(row.original)}
        variant="dimmed"
      />
    </div>
  );
};
